import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const switchRoleApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.SWITCH_ROLE,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
